
























import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { SearchConditionPresetKinds, DocumentSearchPresetCondition, } from "../../../../domain/document";

@Component
export default class PresetUpdateArea extends Mixins() {
  @Prop()
  presets: DocumentSearchPresetCondition[];

  @Prop()
  selectedPreset: DocumentSearchPresetCondition;

  @Prop()
  isNew: boolean;

  @Prop()
  departmentId: string;

  @Prop()
  shouldSelectDefault: string;

  @Prop()
  isAdministratorDepartment: boolean;

  @Prop()
  isCommonItemEditable: boolean;

  @Emit()
  presetUpdated(key: string): void {}

  data(): any {
    return {
      isProcessiong: false,
      personPreset: SearchConditionPresetKinds.Person,
      departmentPreset: SearchConditionPresetKinds.Department,
      allPreset: SearchConditionPresetKinds.All,
      presetKind: SearchConditionPresetKinds.Person,
      preset: null,
    };
  }
  isProcessiong: boolean;
  personPreset: SearchConditionPresetKinds;
  departmentPreset: SearchConditionPresetKinds;
  allPreset: SearchConditionPresetKinds;
  presetKind: SearchConditionPresetKinds;
  preset: DocumentSearchPresetCondition;

  mounted() {
    this.preset = this.selectedPreset;
  }

  get isDefaultSelected(): boolean {
    return this.preset && this.preset.isDefaultSelected;
  }

  set isDefaultSelected(value: boolean) {
    this.preset.isDefaultSelected = value;
  }

  get presetName(): string {
    return this.preset
      ? this.preset.name
      : "";
  }

  set presetName(value: string) {
    this.preset.name = value;
  }

  async save(): Promise<void> {
    try {
      this.isProcessiong = true;
      if (this.isNew) {
        this.preset.presetKind = this.presetKind;
        this.preset.departmentId = (this.presetKind === SearchConditionPresetKinds.Department) ? this.departmentId : null;

        const lastPreset = Enumerable.from(this.presets)
          .where(c => c.presetKind === this.presetKind)
          .orderByDescending(c => c.index)
          .firstOrDefault();

        this.preset.index = lastPreset ? lastPreset.index + 1 : 1;
      }
      const repository = DomainRegistry.document.getDocumentRepository();
      const key = await repository.registerPresetCondition(this.preset);
      this.presetUpdated(key);
      this.$success("プリセット登録成功", "プリセットの登録に成功しました。");
    } catch (e) {
      this.$error("プリセット登録失敗", "プリセットの登録に失敗しました。", e);
    } finally {
      this.isProcessiong = false;
    }
  }

  @Watch("selectedPreset")
  onSelectedPresetChanged(newValue: DocumentSearchPresetCondition) {
    this.preset = newValue;
  }
}
